import { Heading } from '@flixbus/honeycomb-react';
import { Icon, IconOffer } from '@flixbus/honeycomb-icons-react';

import { useVoucher } from '../../../context/VoucherProdiver';

import RuleDisplay from '../RuleDisplay';

import styles from '../voucher-info.module.scss';

const VoucherInfoRules = () => {
  const {
    data: { rules },
  } = useVoucher();

  if (!rules || rules.length === 0) return null;

  return (
    <div className={styles.container}>
      <Heading sectionHeader extraClasses={styles.rulesTitle} size={3}>
        <span className={styles.rulesIcon}>
          <Icon InlineIcon={IconOffer} />
        </span>
        Additional Rules
      </Heading>
      <RuleDisplay
        title='Trips'
        fields={['minimum_tickets_amount', 'minimum_value', 'direct_ride']}
      />
      <RuleDisplay
        title='Countries and lines'
        fields={[
          'line_whitelist',
          'line_blacklist',
          'brand_allowlist',
          'brand_disallowlist',
          'allowed_countries',
          'forbidden_countries',
        ]}
      />
      <RuleDisplay title='Travel period' fields={['travel_period', 'weekdays_travel']} />
      <RuleDisplay title='Blackout periods' fields={['blackout_period']} />
    </div>
  );
};

export default VoucherInfoRules;
